module.exports = __webpack_public_path__ + "static/media/IconTemplates_-72.3487bda8.svg";